/* dome.js — DOME. landing page behaviour.
   Add to Cart is handled by Horizon's own <product-form-component> (AJAX /cart/add.js).
   That updates the header cart count and the cart drawer contents; this file then OPENS
   the cart drawer (even when "Auto-open cart drawer" is off in Theme settings).
   It never redirects to checkout. Every lookup is guarded so hiding any block cannot throw. */
(function () {
  if (window.DomeLP) { window.DomeLP.initAll(document); return; }

  var DomeLP = {};
  window.DomeLP = DomeLP;

  /* ---------------- money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || '£{{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  DomeLP.formatMoney = formatMoney;

  /* ---------------- cart drawer: open after a successful add ---------------- */
  function openCartDrawer() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      var isOpen = drawer.isOpen === true || drawer.hasAttribute('open');
      if (!isOpen) drawer.open();
      return true;
    }
    if (window.Shopify && Shopify.actions && Shopify.actions.openCart) {
      try { Shopify.actions.openCart(); return true; } catch (e) {}
    }
    return false;
  }
  DomeLP.openCartDrawer = openCartDrawer;

  var eventsWired = false;
  function wireCartEvents() {
    if (eventsWired) return;
    eventsWired = true;
    import('@shopify/events').then(function (mod) {
      var SE = mod.StandardEvents || {};
      if (SE.cartLinesUpdate) {
        document.addEventListener(SE.cartLinesUpdate, function (event) {
          if (event.action && event.action !== 'add') return;
          var t = event.target;
          if (!(t instanceof Element) || !t.closest('[data-dm-root]')) return;
          if (!event.promise || !event.promise.then) { setTimeout(openCartDrawer, 300); return; }
          event.promise.then(function (res) {
            var detail = res && res.detail;
            if (detail && detail.didError) return;
            requestAnimationFrame(function () {
              if (!openCartDrawer()) {
                var url = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
                window.location.href = url;
              }
            });
          }).catch(function () {});
        });
      }
      if (SE.productSelect) {
        document.addEventListener(SE.productSelect, function (event) {
          var t = event.target;
          if (!(t instanceof Element)) return;
          var root = t.closest('[data-dm-product]');
          if (!root || !event.promise || !event.promise.then) return;
          event.promise.then(function (res) {
            var r = res && res.detail && res.detail.resource;
            if (r && r.id) DomeLP.applyVariantId(root, r.id, true);
          }).catch(function () {});
        });
      }
    }).catch(function () { /* events module unavailable: Horizon form still adds to cart */ });
  }

  /* ---------------- gallery ---------------- */
  function initGallery(g) {
    if (g.hasAttribute('data-dm-ready')) return;
    g.setAttribute('data-dm-ready', '');
    var track = g.querySelector('[data-dm-track]');
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-dm-slide]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-dm-thumb]'));
    if (!track || !slides.length) return;

    function indexOfMedia(id) {
      if (!id) return -1;
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === String(id)) return i;
      return -1;
    }
    function markActive(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var th = thumbs[i];
      var strip = th && th.parentElement;
      if (th && strip) {
        var left = th.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + th.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: left - 8, behavior: 'smooth' });
        }
      }
    }
    function goTo(i, instant) {
      if (i < 0 || i >= slides.length) return;
      var prev = track.style.scrollBehavior;
      if (instant) track.style.scrollBehavior = 'auto';
      track.scrollLeft = slides[i].offsetLeft - track.offsetLeft;
      if (instant) track.style.scrollBehavior = prev;
      markActive(i);
      slides.forEach(function (s, n) { if (n !== i) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); } });
    }
    function currentIndex() {
      return Math.max(0, Math.min(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), slides.length - 1));
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { markActive(currentIndex()); });
    }, { passive: true });
    var prevBtn = g.querySelector('[data-dm-prev]');
    var nextBtn = g.querySelector('[data-dm-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { var i = currentIndex(); goTo(i === 0 ? slides.length - 1 : i - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { var i = currentIndex(); goTo(i === slides.length - 1 ? 0 : i + 1); });

    g.dmShowMedia = function (mediaId) {
      var i = indexOfMedia(mediaId);
      if (i > -1) goTo(i);
    };
    var start = indexOfMedia(g.getAttribute('data-initial-media-id'));
    goTo(start > -1 ? start : 0, true);
    window.addEventListener('resize', function () { goTo(currentIndex(), true); });
  }

  /* ---------------- product root: variants, price, stock, button ---------------- */
  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  DomeLP.applyVariantId = function (root, id, fromNative) {
    var data = root.dmData;
    if (!data || !data.variants) return;
    var v = null;
    for (var i = 0; i < data.variants.length; i++) if (String(data.variants[i].id) === String(id)) { v = data.variants[i]; break; }
    if (!v) return;
    applyVariant(root, v, fromNative);
  };

  function applyVariant(root, v, fromNative) {
    var data = root.dmData || {};
    var fmt = data.money_format;
    root.setAttribute('data-selected-variant-id', v.id);

    // 1. every product form inside this section (custom + native) carries the id
    root.querySelectorAll('form input[name="id"], form select[name="id"]').forEach(function (input) {
      if (String(input.value) !== String(v.id)) {
        input.value = v.id;
        if (input.tagName === 'INPUT') input.setAttribute('value', v.id);
        if (!fromNative) input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // 2. price blocks
    var hasSale = v.compare_at_price && v.compare_at_price > v.price;
    root.querySelectorAll('[data-dm-price-now]').forEach(function (el) { el.textContent = formatMoney(v.price, fmt); });
    root.querySelectorAll('[data-dm-price-was]').forEach(function (el) {
      if (hasSale) { el.textContent = formatMoney(v.compare_at_price, fmt); el.hidden = false; } else { el.hidden = true; }
    });
    root.querySelectorAll('[data-dm-price-save]').forEach(function (el) {
      if (!hasSale) { el.hidden = true; return; }
      var prefix = el.getAttribute('data-prefix') || '';
      var mode = el.getAttribute('data-mode') || 'percent';
      var txt = mode === 'amount'
        ? formatMoney(v.compare_at_price - v.price, fmt)
        : Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      el.textContent = (prefix ? prefix + ' ' : '') + txt;
      el.hidden = false;
    });

    // 3. stock blocks
    root.querySelectorAll('[data-dm-stock]').forEach(function (el) {
      var label = el.querySelector('[data-dm-stock-label]');
      var low = Number(el.getAttribute('data-low') || 0);
      var tracked = v.inventory_management === 'shopify' && v.inventory_policy !== 'continue';
      el.classList.remove('is-low', 'is-out');
      var text;
      if (!v.available) { text = el.getAttribute('data-out'); el.classList.add('is-out'); }
      else if (tracked && low > 0 && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
        text = (el.getAttribute('data-low-text') || '').replace('[count]', v.inventory_quantity); el.classList.add('is-low');
      } else { text = el.getAttribute('data-in'); }
      if (label && text) label.textContent = text;
    });

    // 4. custom Add to Cart buttons
    root.querySelectorAll('[data-dm-atc]').forEach(function (btn) {
      btn.disabled = !v.available;
      var lab = btn.querySelector('[data-dm-atc-label]');
      if (lab) lab.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
      var now = btn.querySelector('[data-dm-atc-now]');
      if (now) now.textContent = formatMoney(v.price, fmt);
      var was = btn.querySelector('[data-dm-atc-was]');
      if (was) { if (hasSale) { was.textContent = formatMoney(v.compare_at_price, fmt); was.hidden = false; } else { was.hidden = true; } }
      var media = v.featured_image_url;
      var comp = btn.closest('add-to-cart-component');
      if (comp && media) comp.setAttribute('data-product-variant-media', media);
    });

    // 5. custom picker selected state
    root.querySelectorAll('[data-dm-picker]').forEach(function (picker) {
      picker.querySelectorAll('[data-dm-opt]').forEach(function (btn) {
        var pos = Number(btn.getAttribute('data-pos'));
        var on = v.options[pos - 1] === btn.getAttribute('data-value');
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      picker.querySelectorAll('[data-dm-opt-current]').forEach(function (s) {
        var pos = Number(s.getAttribute('data-pos'));
        s.textContent = v.options[pos - 1] || '';
      });
      markUnavailable(picker, data.variants, v);
    });

    // 6. gallery follows the variant (only when the variant has its own image)
    if (v.featured_media_id) {
      var g = root.querySelector('[data-dm-gallery]');
      if (g && g.dmShowMedia) g.dmShowMedia(v.featured_media_id);
    }

    // 7. url + rest of the page (sticky bar)
    if (root.hasAttribute('data-update-url') && window.history && history.replaceState) {
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('dome:variant:change', { detail: { variant: v, root: root } }));
  }

  function markUnavailable(picker, variants, current) {
    picker.querySelectorAll('[data-dm-opt]').forEach(function (btn) {
      var pos = Number(btn.getAttribute('data-pos'));
      var val = btn.getAttribute('data-value');
      var ok = variants.some(function (x) {
        if (!x.available || x.options[pos - 1] !== val) return false;
        for (var k = 0; k < x.options.length; k++) { if (k !== pos - 1 && x.options[k] !== current.options[k]) return false; }
        return true;
      });
      btn.classList.toggle('is-unavail', !ok);
    });
  }

  function initProduct(root) {
    if (root.hasAttribute('data-dm-ready')) return;
    root.setAttribute('data-dm-ready', '');
    root.dmData = readJSON(root, '[data-dm-json]') || {};
    var variants = root.dmData.variants || [];

    var g = root.querySelector('[data-dm-gallery]');
    if (g) initGallery(g);

    // custom variant picker
    root.querySelectorAll('[data-dm-picker]').forEach(function (picker) {
      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-dm-opt]');
        if (!btn) return;
        var cur = null, sel = root.getAttribute('data-selected-variant-id');
        for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(sel)) cur = variants[i];
        var wanted = cur ? cur.options.slice() : (variants[0] ? variants[0].options.slice() : []);
        wanted[Number(btn.getAttribute('data-pos')) - 1] = btn.getAttribute('data-value');
        var match = null;
        for (var j = 0; j < variants.length; j++) {
          if (variants[j].options.join('||') === wanted.join('||')) { match = variants[j]; break; }
        }
        if (!match) {
          // nearest: same value for the clicked option, prefer available
          var pos = Number(btn.getAttribute('data-pos')) - 1;
          var cands = variants.filter(function (x) { return x.options[pos] === wanted[pos]; });
          match = cands.filter(function (x) { return x.available; })[0] || cands[0] || null;
        }
        if (match) applyVariant(root, match, false);
      });
    });

    // any id input written by something else (native picker, apps) → follow it
    root.querySelectorAll('form input[name="id"], form select[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () { DomeLP.applyVariantId(root, input.value, true); });
      if (window.MutationObserver) {
        new MutationObserver(function () { DomeLP.applyVariantId(root, input.value, true); })
          .observe(input, { attributes: true, attributeFilter: ['value'] });
      }
    });

    // quantity steppers in the custom buy block
    root.querySelectorAll('[data-dm-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[name="quantity"]');
      if (!input) return;
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dm-step]');
        if (!b) return;
        var n = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-dm-step')));
        input.value = n;
      });
    });

    var sel = root.getAttribute('data-selected-variant-id');
    var start = null;
    for (var k = 0; k < variants.length; k++) if (String(variants[k].id) === String(sel)) start = variants[k];
    if (start) root.querySelectorAll('[data-dm-picker]').forEach(function (p) { markUnavailable(p, variants, start); });
  }

  /* ---------------- time calculator ---------------- */
  function initCalc(sec) {
    if (sec.hasAttribute('data-dm-ready')) return;
    sec.setAttribute('data-dm-ready', '');
    var range = sec.querySelector('[data-dm-range]');
    var pills = Array.prototype.slice.call(sec.querySelectorAll('[data-dm-freq]'));
    var saving = Number(sec.getAttribute('data-saving') || 80) / 100;
    var perWeek = 7;
    var on = pills.filter(function (p) { return p.classList.contains('is-on'); })[0] || pills[0];
    if (on) perWeek = Number(on.getAttribute('data-per-week')) || 7;

    function render() {
      var t = Number(range ? range.value : sec.getAttribute('data-default') || 15);
      var newT = Math.round(t * (1 - saving) * 10) / 10;
      var savedMinYear = (t - newT) * perWeek * 52;
      var hours = Math.round(savedMinYear / 60);
      var days = Math.round(savedMinYear / 60 / 24 * 10) / 10;
      sec.querySelectorAll('[data-dm-time]').forEach(function (el) { el.textContent = t; });
      sec.querySelectorAll('[data-dm-newtime]').forEach(function (el) { el.textContent = newT; });
      sec.querySelectorAll('[data-dm-hours]').forEach(function (el) { el.textContent = hours; });
      sec.querySelectorAll('[data-dm-days]').forEach(function (el) { el.textContent = days; });
      var fill = sec.querySelector('[data-dm-newfill]');
      if (fill) fill.style.width = Math.max(4, Math.round((1 - saving) * 100)) + '%';
    }
    if (range) range.addEventListener('input', render);
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (x) { x.classList.toggle('is-on', x === p); x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
        perWeek = Number(p.getAttribute('data-per-week')) || 7;
        render();
      });
    });
    render();
  }

  /* ---------------- review lightbox ---------------- */
  function initReviews(sec) {
    if (sec.hasAttribute('data-dm-ready')) return;
    sec.setAttribute('data-dm-ready', '');
    var dlg = sec.querySelector('[data-dm-lightbox]');
    if (!dlg) return;
    var img = dlg.querySelector('img');
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dm-zoom]');
      if (!b || !img) return;
      img.src = b.getAttribute('data-dm-zoom');
      img.alt = b.getAttribute('data-alt') || '';
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-dm-close]')) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    });
  }

  /* ---------------- scroll links (final CTA → buy box) ---------------- */
  function initScrollLinks(scope) {
    scope.querySelectorAll('[data-dm-scroll]').forEach(function (a) {
      if (a.hasAttribute('data-dm-ready')) return;
      a.setAttribute('data-dm-ready', '');
      a.addEventListener('click', function (e) {
        var target = document.querySelector('[data-dm-buy]') || document.querySelector('[data-dm-product]');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ---------------- sticky add to cart ---------------- */
  function findBuyForm() {
    var f = document.querySelector('[data-dm-buy] form');
    if (f) return f;
    var forms = document.querySelectorAll('[data-dm-product] product-form-component form');
    return forms[0] || null;
  }
  function initSticky(bar) {
    if (bar.hasAttribute('data-dm-ready')) return;
    bar.setAttribute('data-dm-ready', '');
    var btn = bar.querySelector('[data-dm-sticky-btn]');
    var target = document.querySelector('[data-dm-buy]') || document.querySelector('[data-dm-product]');
    if (target && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (e.isIntersecting) seen = true;
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past || (!e.isIntersecting && seen && e.boundingClientRect.top < 0));
      }, { threshold: 0 }).observe(target);
    } else {
      bar.classList.add('is-visible');
    }
    if (btn) btn.addEventListener('click', function () {
      var form = findBuyForm();
      if (!form) { if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var submit = form.querySelector('[type="submit"][name="add"]');
      if (submit && submit.disabled) return;
      if (form.requestSubmit) form.requestSubmit(submit || undefined);
      else if (submit) submit.click();
    });
    document.addEventListener('dome:variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      var root = e.detail && e.detail.root;
      if (!v) return;
      var fmt = root && root.dmData && root.dmData.money_format;
      var now = bar.querySelector('[data-dm-sticky-now]');
      var was = bar.querySelector('[data-dm-sticky-was]');
      if (now) now.textContent = formatMoney(v.price, fmt);
      if (was) {
        if (v.compare_at_price > v.price) { was.textContent = formatMoney(v.compare_at_price, fmt); was.hidden = false; } else { was.hidden = true; }
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
      }
    });
  }

  /* ---------------- boot ---------------- */
  DomeLP.initAll = function (scope) {
    scope = scope || document;
    wireCartEvents();
    scope.querySelectorAll('[data-dm-product]').forEach(initProduct);
    scope.querySelectorAll('[data-dm-calc]').forEach(initCalc);
    scope.querySelectorAll('[data-dm-reviews]').forEach(initReviews);
    scope.querySelectorAll('[data-dm-sticky]').forEach(initSticky);
    initScrollLinks(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { DomeLP.initAll(document); });
  } else {
    DomeLP.initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { DomeLP.initAll(e.target || document); });
})();
